import { SignIn, SignUp } from "@clerk/react";
import { WaveMark } from "@/components/brand/Logo";

const AuthLayout = ({ title, text, children }) => (
  <div className="grid min-h-[75vh] lg:grid-cols-2 gap-10 items-center">
    <div className="hidden lg:flex flex-col gap-5">
      <WaveMark className="h-14 w-14" />
      <h1 className="font-display text-5xl font-extrabold tracking-tight chrome-text">{title}</h1>
      <p className="max-w-md text-slate-400 leading-relaxed">{text}</p>
    </div>
    <div className="flex items-center justify-center">{children}</div>
  </div>
);

export function SignInPage() {
  return (
    <AuthLayout title="Welcome back to the wave." text="Sign in to manage your profile and follow the next generation of AI artists.">
      <SignIn routing="path" path="/sign-in" signUpUrl="/sign-up" withSignUp />
    </AuthLayout>
  );
}

export function SignUpPage() {
  return (
    <AuthLayout title="Ride the NEW WAVE." text="Create your account, then choose: AI Creator or Fan. Fans join free, forever.">
      <SignUp routing="path" path="/sign-up" signInUrl="/sign-in" />
    </AuthLayout>
  );
}
